export default function sniffer() {
    // Sniff out FF
    const isFF = !!window.sidebar;
    window.isFF = isFF;
    // add ff body class
    isFF ? document.querySelector("body").classList.add("is-firefox") : ``;
}



// WEBPACK FOOTER //
// ./src/sniffer.js